import React from 'react'
import { Link } from 'react-router-dom'

const Tedx = () => {
    return (
        <div>
            {/* width="630" height="400"  */}
            <div data-aos="fade-up" className="flex flex-col md:flex-row items-center gap-4 lg:gap-2 justify-center lg:px-16 p-4">
                <div className="md:w-1/2 w-full lg:py-4 lg:pr-4">
                    <iframe
                        className="w-full aspect-video"
                        src="https://www.youtube.com/embed/2RBt2KVrRuY"
                        title="Demystifying Executive Presence | Kshitij Sharma | TEDxManSagarLake"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>

                <div data-aos="fade-up" className="md:w-1/2  ">
                    <h1  style={{ fontFamily: "Helvetica" }}  className="text-3xl font-bold mb-4">Check out
                        <a rel="noreferrer" href="https://coachkshitij.com/about-us/" target='_blank'><span className="text-blue-500"> Coach Kshitij's  </span></a>
                        TEDx Talk 'Demystifying Executive Presence', the most highly regarded presentation on the subject.</h1>
                    <p className="text-gray-700 text-justify  text-lg">
                        In his TEDx talk, Kshitij Sharma sheds light on the often elusive concept of Executive Presence, breaking it down into practical and actionable insights. He explores how leaders can cultivate presence not just through their words, but through their demeanor, decisions, and impact on others. By demystifying Executive Presence, Kshitij empowers leaders to embrace authenticity, build trust, and project confidence in high-stakes environments, ultimately helping them drive organizational success and inspire teams to reach their highest potential.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Tedx